import a from "axios";
import {
  API_VERSION,
  BACKEND_URL,
  BACKEND_URL_PROTOCOL,
} from "../../constants/Settings";
// import { siteState } from "../../models/states/useSiteState";
import { actions, store } from "../../store/useStore";

// const _authState = store.auth.state();
const params = new URLSearchParams(window.location.search);
const client_number = params.get('client_number');

const axios = a.create({
  baseURL: `${BACKEND_URL_PROTOCOL}inventory-api.${BACKEND_URL}/${API_VERSION}`,
  headers: {
    "Content-Type": "application/json",
    // Authorization: `Bearer ${Cookies.get("session")}`,
    "fi-client-number": client_number?.toUpperCase(),
    // "fi-device-number": store.auth.activeDeviceIdentifier(),
  },
});

axios.interceptors.request.use(
  (config) => {
    const token = store.auth.authToken();
    const refreshtoken = store.auth.refreshToken();
    const role = store.auth.activeRole()?.identifier;
    const isRefreshTokenAPI = config.url?.includes("auth/refresh-token");
    // const token = Cookies.get("session");

    // const role = roleState().activeRole?.identifier;

    if (token) {
      if (!config.headers.hasOwnProperty("fi-device-number")) {
        config.headers["fi-device-number"] =
          store.auth.activeDeviceIdentifier();
      }

      if (
        config.headers.hasOwnProperty("fi-device-number") &&
        (config.headers["fi-device-number"] === "" ||
          config.headers["fi-device-number"] === null ||
          config.headers["fi-device-number"] === undefined)
      ) {
        config.headers["fi-device-number"] =
          store.auth.activeDeviceIdentifier();
      }
    }

    if (token) {
      config.headers.Authorization = !isRefreshTokenAPI
        ? `Bearer ${token}`
        : `Bearer ${refreshtoken}`;

      // config.headers.Authorization = `Bearer ${token}`;
      config.headers["X-ROLE"] = role;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

axios.interceptors.response.use(
  function (response: any) {
    return response;
  },
  async function (error: any) {
    if (error.response.status === 401) {
      // getAuthState().setUser(null);
      // getAuthState().setIsLoggedIn(false);
      // window.location.href = "/signin";
      actions.auth.logout();

      // TODO: Implement Refresh Token Functionality
      // try {
      //   const res = await axios.get("/auth/get_access_token", {
      //     headers: {
      //       "Content-Type": "application/json",
      //       Authorization: `Bearer ${Cookies.get("refresh-token")}`,
      //     },
      //   });
      //   Cookies.set("session", res.data.token.accessToken);
      // } catch (error) {
      // }
    }

    error?.response.data.errors?.forEach((error: any) => {
      // notifications.show({
      //   title: error.message ?? "Something went wrong",
      //   message: "",
      //   bg: "red",
      //   styles: {
      //     title: {
      //       color: "white",
      //     },
      //   },
      // });
      actions.core.throwError(error.message ?? "Something went wrong");
    });
  }
);

export default axios;
